//@ts-nocheck
//@ts-ignore
export const dateTimeRegex =
  /^\s*(?<days>\d{1,2})-(?<months>\d{1,2})-(?<years>\d{4})\s+(?<hours>\d{1,2}):(?<minutes>\d{1,2}):(?<seconds>\d{1,2})\s*$/i;

/**
 * Converts the api format used for dates in a valid ISO-8601 timestamp.
 * @param datetime format used by the api, see regex
 * Although the provided timestamp does not contain a timezone the backend team
 * has clearly stated that the offset is 'GMT+2'.
 * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
 */

export default function convertApiDateTimeToIsoInstant(
  datetime: string,
  timezone?: boolean,
): string | null {
  if (!isNaN(datetime)) return convertTimestampToIsoInstant(datetime, timezone);

  const regexOutput = dateTimeRegex.exec(datetime);

  if (!regexOutput || !regexOutput.groups) {
    return null;
  }

  const {
    groups: { days, months, years, hours, minutes, seconds },
  } = regexOutput;
  if (timezone) {
    return `${years}-${months}-${days}T${hours}:${minutes}:${seconds}`;
  }
  return `${years}-${months}-${days}T${hours}:${minutes}:${seconds}+02:00`;
}

//TODO QUESTO È OVVIAMENTE UN ACCROCCO È STATO FATTO PERCHÈ PER QUALCHE FOLLE MOTIVO IL BACKEND HA DECISO DI FORNIRCI UN TIMESTAMP INVECE CHE UNA DATA IN UN FORMATO STANDARD,
//QUINDI ABBIAMO DOVUTO FARE QUESTO PER METTERE UNA PEZZA, IDEALMENTE DOVREI CHIEDERE AL BE UNA FIX
function convertTimestampToIsoInstant(
  timestamp: string,
  timezone?: boolean,
): string | null {
  const date = new Date(Number(timestamp));

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const offsetDate = new Date(date.getTime() + 2 * 60 * 60 * 1000);

  const pad = (value: number) => String(value).padStart(2, '0');

  const years = offsetDate.getUTCFullYear();
  const months = pad(offsetDate.getUTCMonth() + 1);
  const days = pad(offsetDate.getUTCDate());
  const hours = pad(offsetDate.getUTCHours());
  const minutes = pad(offsetDate.getUTCMinutes());
  const seconds = pad(offsetDate.getUTCSeconds());

  if (timezone) {
    return `${years}-${months}-${days}T${hours}:${minutes}:${seconds}`;
  }

  return `${years}-${months}-${days}T${hours}:${minutes}:${seconds}+02:00`;
}
